import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import styles from './PhoneMockup.module.css';
import img from '../assets/8.jpg';

const PhoneMockup = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  
  // Parallax the individual image inside its own wrapper instead of the giant background
  const yImage = useTransform(scrollYProgress, [0, 1], [-40, 40]);
  const scaleImage = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  
  // Subtle float on the entire image card container
  const yCard = useTransform(scrollYProgress, [0, 1], [60, -60]);

  const containerVars = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { staggerChildren: 0.12 }
    }
  };

  const itemVars = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <section ref={ref} className={styles.section}>
      <div className={styles.container}>
        <motion.div 
          className={styles.textContent}
          variants={containerVars}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.h2 variants={itemVars} className={styles.title}>
            Always in your pocket.
          </motion.h2>
          <motion.p variants={itemVars} className={styles.body}>
            Measure. Map. Explore.
          </motion.p>
        </motion.div>

        <div className={styles.imageWrapper}>
          <motion.div 
            className={styles.imageCard}
            style={{ y: yCard }}
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          >
            <motion.div 
              className={styles.imageInner}
              style={{ 
                backgroundImage: `url(${img})`,
                y: yImage,
                scale: scaleImage
              }}
            />
            <div className={styles.imageGradient} />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PhoneMockup;
